import React, { useEffect, useState } from "react"
import { formatDateDataGrid } from "src/utils/format-date"
import PropTypes from 'prop-types'
import dayjs from "dayjs"
import { DATE_FORMAT } from "src/utils/constants"
import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterDatalakeCVMComposicaoCapitalTable = (props) => {
    const dataLakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint).then((response) => {
            props.loading(false)

            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj, index) => ({ ...obj, id: index }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const createRow = async () => {
        const body = {
            "ID_DF": null,
            "CPFCNPJ": null,
            "DataReferencia": null,
            "Versao": null,
            "QtAcaoOrdinCapIntegr": null,
            "QtAcaoPrefCapIntegr": null,
            "QtAcaoTotalCapIntegr": null,
            "QtAcaoOrdinTesouro": null,
            "QtAcaoPrefTesouro": null,
            "QtAcaoTotalTesouro": null, 
            "BaseBalanco": null,
            "Ano": null,
        }

        console.log("DataReferencia:", body.DataReferencia)

        props.loading(true)
        return dataLakeService.createTableEndpoint(props.endpoint, body).then(() => {
            props.loading(false)
            loadData(0, 25)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const updateRow = async (newRow) => {
        const { ID, ID_DF, CPFCNPJ, DataReferencia, Versao, QtAcaoOrdinCapIntegr, QtAcaoPrefCapIntegr, QtAcaoTotalCapIntegr, QtAcaoOrdinTesouro, QtAcaoPrefTesouro, QtAcaoTotalTesouro, BaseBalanco, Ano
        } = newRow

        const body = {
            "ID_DF": ID_DF,
            "DataReferencia": DataReferencia,
            "CPFCNPJ": CPFCNPJ,
            "Versao": Versao,
            "QtAcaoOrdinCapIntegr": QtAcaoOrdinCapIntegr,
            "QtAcaoPrefCapIntegr": QtAcaoPrefCapIntegr,
            "QtAcaoTotalCapIntegr": QtAcaoTotalCapIntegr,
            "QtAcaoOrdinTesouro": QtAcaoOrdinTesouro,
            "QtAcaoPrefTesouro": QtAcaoPrefTesouro,
            "QtAcaoTotalTesouro": QtAcaoTotalTesouro,
            "BaseBalanco": BaseBalanco,
            "Ano": Ano,

        }

        props.loading(true)
        return dataLakeService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const deleteRow = async (row) => {
        props.loading(true)
        const { ID } = row
        return dataLakeService.deleteTableEndpoint(props.endpoint, ID).then(() => {
            props.loading(false)
            const listRemoved = data.filter((item) => item.ID !== ID)
            setData(listRemoved)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList.map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`).join('&')

        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint, query, limit, offset).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const changePage = async (endpoint) => {
        props.loading(true)
        dataLakeService.paginate(endpoint).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, previous, next } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData([])
            setData(list)
        })
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 80,
        },
        {
            field: 'ID_DF',
            headerName: 'ID_DF',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CPFCNPJ',
            headerName: 'CPFCNPJ',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'DataReferencia',
            headerName: 'DataReferencia',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            typeComponent: 'date',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
                        valueFormatter: ({ value }) => value instanceof Date && !isNaN(value) ? dayjs(value).format(DATE_FORMAT): '',
            disableColumnMenu: true,
            editable: true,
        },
        {
            field: 'Versao',
            headerName: 'Versao',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'QtAcaoOrdinCapIntegr',
            headerName: 'QtAcaoOrdinCapIntegr',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'QtAcaoPrefCapIntegr',
            headerName: 'QtAcaoPrefCapIntegr',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'QtAcaoTotalCapIntegr',
            headerName: 'QtAcaoTotalCapIntegr',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'QtAcaoOrdinTesouro',
            headerName: 'QtAcaoOrdinTesouro',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'QtAcaoPrefTesouro',
            headerName: 'QtAcaoPrefTesouro',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'QtAcaoTotalTesouro',
            headerName: 'QtAcaoTotalTesouro',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'BaseBalanco',
            headerName: 'BaseBalanco',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Ano',
            headerName: 'Ano',
            flex: 1,
            minWidth: 150,
            maxWidth: 350,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <div>
            <ParameterPaginationTable
                columns={columns}
                data={data}
                setData={setData}
                createRow={createRow}
                deleteRow={deleteRow}
                updateRow={updateRow}
                filterFunction={onFilter}
                pagination={pagination}
                onChangePage={changePage}
                customFilter={true} />
        </div>
    )
}

ParameterDatalakeCVMComposicaoCapitalTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
}

export default ParameterDatalakeCVMComposicaoCapitalTable